import React from "react";
import {  ShopPayButton } from "@shopify/hydrogen-react";
import AddToCartSection from "../AddToCartSection";
import BuyNowButton from "./BuyNowButton";

interface ProductVariant {
  id: string;
  title: string;
  price: {
    amount: string;
    currencyCode: string;
  };
  availableForSale: boolean;
  selectedOptions: Array<{
    name: string;
    value: string;
  }>;
}

interface ShopButtonsProps {
  selectedVariant: ProductVariant | null;
  quantity: number;
  onAddToCartSuccess?: () => void;
}

export default function ShopButtons({
  selectedVariant,
  quantity,
  onAddToCartSuccess,
}: ShopButtonsProps) {
  return (
    <div className="space-y-4">
      {/* Add to Cart Section */}
      <AddToCartSection
        selectedVariant={selectedVariant}
        quantity={quantity}
        onAddToCartSuccess={onAddToCartSuccess}
      />

      {/* Shop Pay Button */}
      {selectedVariant && selectedVariant.availableForSale && (
        <div className="mt-3">
          <BuyNowButton variantId={selectedVariant.id} quantity={quantity} />
        </div>
      )}
    </div>
  );
}
